export default "__VITE_ASSET__DzLIdnqb__"